export default __webpack_public_path__ + "static/media/about_us_triangle.a6163aad.svg";